import { css } from 'lit';

export const timeSliderElementStyles = css``;
